import { render, staticRenderFns } from "./DepartmentListEditModal.vue?vue&type=template&id=58a76d58&scoped=true&"
import script from "./DepartmentListEditModal.vue?vue&type=script&lang=js&"
export * from "./DepartmentListEditModal.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentListEditModal.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./DepartmentListEditModal.vue?vue&type=style&index=1&id=58a76d58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a76d58",
  null
  
)

export default component.exports